/**
 * 海外版功能模块权限
 */

export default {
  'entry.wm': true, // 外卖
  'entry.yd': true, // 预订
  'entry.hy': false, // 会员
  'entry.pd': true, // 排队
  'vip.charge': false, // 充值
  'vip.address': false, // 地址
  'order.checkout': true, // 结账
  'order.submit': false, // 提交订单
};



// WEBPACK FOOTER //
// ./src/permission/area-permissions/oversea.js